export const mergeServerValues = <T extends object>(
  previousServerValues: T,
  nextServerValues: T,
  currentValues: T,
): T => {
  const merged = { ...currentValues };
  for (const key of Object.keys(nextServerValues) as (keyof T)[]) {
    if (currentValues[key] === previousServerValues[key]) {
      merged[key] = nextServerValues[key];
    }
  }
  return merged;
};
